import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import TemplateTask from '../../entities/templateTask';
import CaseTypeStage from '../../entities/caseTypeStage';
import Task from '../../entities/task';
export function deleteTemplateTask(templateTask: TemplateTask, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = templateTask.id;}
const _work = workingSet();
store.getState().caseTypeStages.getMappingFor('templateTaskIds', templateTask.id).filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D').forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
_caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.filter(id => id !== templateTask.id) || [];

_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
store.getState().tasks.getMappingFor('fromTemplateId', templateTask.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.fromTemplateId === templateTask.id) {
_task.fromTemplateId = null;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



templateTask.status = 'D';
templateTask.addedOn = newHRTimestamp();
templateTask.addedBy = getCurrentUserId();
templateTask.importSource = targetImportSource;
templateTask.importId = mergeId;
store.dispatch(Actions.TemplateTaskActions.removeTemplateTaskQueue(templateTask));
}
export function replaceTemplateTask(templateTask: TemplateTask, replaceWith: TemplateTask, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = templateTask.id;}
const _work = workingSet();
store.getState().caseTypeStages.getMappingFor('templateTaskIds', templateTask.id).filter(caseTypeStageTemp => caseTypeStageTemp.status !== 'D').forEach(caseTypeStageTemp => {
const _caseTypeStage = ((_work.get('caseTypeStage:' + caseTypeStageTemp.id) ?? caseTypeStageTemp) as CaseTypeStage).clone();
_caseTypeStage.status = 'U';
_caseTypeStage.addedOn = newHRTimestamp();
_caseTypeStage.addedBy = getCurrentUserId();
_caseTypeStage.importSource = targetImportSource;
_caseTypeStage.importId = mergeId;
_caseTypeStage.templateTaskIds = _caseTypeStage.templateTaskIds?.map(id => (id === templateTask.id) ? replaceWith.id : id) || [];

_work.set('caseTypeStage:' + _caseTypeStage.id, _caseTypeStage);
store.dispatch(Actions.CaseTypeStageActions.saveCaseTypeStageQueue(_caseTypeStage));
});
store.getState().tasks.getMappingFor('fromTemplateId', templateTask.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.fromTemplateId === templateTask.id) {
_task.fromTemplateId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return templateTask;
}
export function deleteImpactTemplateTask(templateTask: TemplateTask) {
const impacts: string[] = [];
const state = store.getState();
const caseTypeStageTemplateTaskIdsImpact = state.caseTypeStages.getMappingFor('templateTaskIds', templateTask.id).filter(caseTypeStage => caseTypeStage.status !== 'D');
caseTypeStageTemplateTaskIdsImpact.forEach(() => impacts.push('caseTypeStages'));
const taskFromTemplateIdImpact = state.tasks.getMappingFor('fromTemplateId', templateTask.id).filter(task => task.status !== 'D');
taskFromTemplateIdImpact.forEach(() => impacts.push('tasks'));



return util.countDistinct(impacts);
}
